module.exports = __webpack_public_path__ + "fonts/Tangerine-700-latin23.4cd5e9d.woff2";